import script from "./Button.vue?vue&type=script&lang=ts&setup=true"
export * from "./Button.vue?vue&type=script&lang=ts&setup=true"

import "./Button.vue?vue&type=style&index=0&id=a74b3efa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4153695745/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a74b3efa"]])

export default __exports__